import {useStore} from '@nanostores/react';
import {
  AddressClient,
  MetadataClient,
  OrderDocumentClient,
  OrderMonitorClient,
  UnitPriceClient,
  UserInfoClient,
  RegistryClient,
  RegistrationClient,
} from '@api/prime-documents-api';
import {$authSession} from '@stores/AuthStore';
import {$appSecrets} from '@stores/AppUIStore';

const usePrimeDocsAPI = () => {
  const authSession = useStore($authSession);
  const appSecrets = useStore($appSecrets);

  const ACCESS_TOKEN = authSession?.accessToken;
  const DOCS_API_URL = appSecrets.primeDocApiUrl;

  const http = (url: RequestInfo, init?: RequestInit) => {
    if (init) {
      init.headers = {
        ...init.headers,
      };
      if (ACCESS_TOKEN) {
        init.headers = {
          ...init.headers,
          Authorization: `Bearer ${ACCESS_TOKEN}`,
        };
      }
    }

    return fetch(url, init);
  };

  const metadataClient = new MetadataClient(DOCS_API_URL, {fetch: http});
  const orderDocumentClient = new OrderDocumentClient(DOCS_API_URL, {fetch: http});
  const orderMonitorClient = new OrderMonitorClient(DOCS_API_URL, {fetch: http});
  const unitPriceClient = new UnitPriceClient(DOCS_API_URL, {fetch: http});
  const userInfoClient = new UserInfoClient(DOCS_API_URL, {fetch: http});
  const registryClient = new RegistryClient(DOCS_API_URL, {fetch: http});
  const registrationClient = new RegistrationClient(DOCS_API_URL, {fetch: http});
  const addressClient = new AddressClient(DOCS_API_URL, {fetch: http});

  return {
    metadataClient,
    orderDocumentClient,
    orderMonitorClient,
    unitPriceClient,
    userInfoClient,
    registryClient,
    registrationClient,
    addressClient,
  };
};

export default usePrimeDocsAPI;
